// Provides a function that returns whether or not the user is logged in.

import Sentry from '../../sentry';
import getAuthToken from './getAuthToken';

import { setAuthCookie } from './web/ManageAuthCookie';

const isSignedIn = async () => {
  try {
    const JWToken = await getAuthToken();

    if (JWToken) {
      setAuthCookie(JWToken);
    }

    if (JWToken) {
      return true;
    }

    return false; // Apparently returns true if that object is truthy?
  } catch (error) {
    Sentry.captureException(error);
    return false;
  }
};

export default isSignedIn;
